import { Routes } from '@App/paths';

export const getProjectPath = (projectId: number | string) => `/project/${projectId}`;

export const getFundPath = (fundId: number | string, accessCode?: string | null) =>
  Routes.FUND_DETAILS(Number(fundId), accessCode);

export const getGroupProfilePath = (organizationId: number | string) =>
  `/group-profile/${organizationId}`;

export const getFunderProfilePath = (organizationId: number | string) =>
  `/funder-profile/${organizationId}`;
